import React, { useEffect } from "react";
import { useDesktopType } from "src/hooks";
import styles from "./style.module.scss";
// import MuteBellButton from "./MuteBellButton";

import DialogList from "./DialogList";

const {
  wrap,
  wrap_desktop,
} = styles;

export interface ChatProps {
  onClose?: () => void;
  onClickHeader?: () => void;
  type: "mobile" | "desktop";
  isOpen: boolean;
}

const Chat = (props: ChatProps) => {
  const isDesktop = useDesktopType();

  useEffect(() => {
    isDesktop && props.onClose?.();
  }, [isDesktop]);

  return (
    <>
      {/*{isDesktop && (*/}
      {/*  <img*/}
      {/*    src={Arrow}*/}
      {/*    className={arrow}*/}
      {/*  />*/}
      {/*)}*/}
      <div
        className={[
          wrap,
          props.type === "desktop" && wrap_desktop,
          // !props.isOpen && wrap_shadow,
        ].join(" ")}
      >
        <DialogList
          deviceType={props.type}
          isOpen={props.isOpen}
          onClose={props.onClose}
          onClickHeader={props.onClickHeader}
        />
      </div>
    </>
  );
};

export default Chat;